<template>
  <b-card>
    <div class="row mb-3 mt-3">
      <div class="col-md-3">
        <b-button-group>
          <b-button :variant="isShowContent == 1 ? 'outline-danger' : 'outline-info'" v-if="item.type === 'forum'"
            @click="show_forum()">
            {{
              isShowContent == 1
                ? $t("activities.hide_forum")
                : $t("activities.show_forum")
            }}
          </b-button>
        </b-button-group>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input v-model="search" type="text" autofocus class="form-control" :placeholder="$t(`site.search`)"
            @input="(val) => searchChange(val)" />
        </div>
      </div>
      <div class="col-3">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown id="ddown2" right :text="`${perPage}`" variant="outline-warning" size="xs">
            <b-dropdown-item v-for="(size, index) in [5, 10, 20, 50, 100]" :key="index" @click="changePageSize(size)">
              {{ size }}
            </b-dropdown-item>
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="$mobile == 1" ref="table" class="vuetable" sort-by="id" sort-desc.sync="false"
          :current-page="currentPage" :fields="bootstrapTable.fields" :items="dataProvider">
          <template #cell(checkbox)="data">
            <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
              <input v-model="recordIds" type="checkbox" :value="data.item.id" @change="selectItem(data)" />
              <span />
            </label>
          </template>
          <template #cell(correct_and_review)="data">
            <b-button variant="outline-info" @click="pass_student_data(data.item)" :to="{ name: 'studentAnswers' }">
              {{ $t("activities.correct_and_review") }}
            </b-button>
          </template>
        </b-table>
        <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />
        <hr />
        <b-pagination v-model="currentPage" align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning" :total-rows="totalRows"
          :per-page="perPage">
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>

        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <div class="row">
      <b-col v-if="isShowContent == 1">
        <forum-vue :item="item" />
      </b-col>
    </div>
  </b-card>
</template>

<script>
import controller from "../../../../Controllers/ActivitiesController";
import config from "../../../../config/config";
import ActivityFiltersVue from "./ActivityFilters.vue";
import quizVue from "./quiz.vue";
import Auth from "@/Apis/Auth";
import Activity from "@/Apis/Activities";
import forumVue from "./forum.vue";
export default {
  name: "ActivitiesDataTable",
  props: ["items", "editItem"],
  components: {
    ActivityFiltersVue,
    quizVue,
    forumVue,
  },
  data() {
    return {
      filters: {},
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          {
            key: "code",
            label: this.$i18n.t("students.academic_number"),
            sortable: true,
          },
          {
            key: "full_name",
            label: this.$i18n.t("students.full_name"),
            sortable: true,
          },
          {
            key: "grade",
            label: this.$i18n.t("activities.grade"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "correct_and_review",
            label: this.$i18n.t("activities.correct_and_review"),
            sortable: false,
            sortDirection: "desc",
          },
        ],
      },
      data: {},
      selectAll: false,

      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      item: {},
      isShowContent: 0,
      studentflage: 1,
    };
  },
  created() {
    // console.log(",aaaaa");
    // console.log(Auth.USER);
  },
  methods: {
    pass_student_data(student) {
      //console.log(student);
      //console.log(this.item);
      Activity.STUDENT = student;
      Activity.ACTIVITY = this.item;
    },
    show_forum() {
      if (this.isShowContent == 1) {
        this.isShowContent = 0;
      } else {
        this.isShowContent = 1;
      }
    },
    updates() {
      this.$refs.table.refresh();
    },
    questions(item) {
      this.questionsArr = item.questions;
      this.questionsType = item.type;
      //console.log(this.questionsArr);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().studentsDataTable(
        this.apiParamsConverter()
      );
      let handledData = this.handleDataTableData(data);
      //console.log(handledData);
      this.currentPage = handledData.current_page;
      this.perPage = handledData.per_page;
      this.totalRows = handledData.total;
      this.from = handledData.from;
      this.to = handledData.to;
      this.total = handledData.total;
      this.data = handledData.data;
      this.load = false;
      return handledData.data;
    },
    handleDataTableData(data) {
      this.item = data.activity;
      console.log(data.data.data);
      data.data.data.forEach((el) => {
        el.answers = data.helpers.filter((e) => e.user_id === el.id);
        el.grade = this.bestGrade(el.answers, data.activity);
      });
      return data.data;
    },
    bestGrade(answers, activity) {
      let max = "-";
      if (answers.length > 0) {
        if (activity.type == "homework" || activity.type == "exam") {
          max = this.best_grade(activity.grade, answers);
          return max;
        }

        const ans = answers.reduce((prev, current) =>
          prev.grade > current.grade ? prev : current
        );
        max = (ans.grade * (activity.grade / 100)).toFixed(2);
      }
      return max;
    },
    // best_grade(activity_grade, answers) {
    //   let grades = [];
    //   for (let i = 1; i <= 3; i++) {
    //     let correct_flag = 0;
    //     let mygrade = 0;
    //     const results = answers.filter((element) => {
    //       return element.answer_number == i;
    //     });
    //     if (results.length > 0) {
    //       results.map((el) => {
    //         if (el.grade != null) {
    //           correct_flag = 1;
    //           mygrade += el.grade;
    //         }
    //       });
    //       grades.push(
    //         correct_flag == 0
    //           ? null
    //           : ((mygrade / results.length) * (activity_grade / 100)).toFixed(2)
    //       );
    //     }
    //   }
    //   if (grades.every((element) => element === null)) {
    //     return "-";
    //   }
    //   //console.log(grades);
    //   return Math.max(...grades);
    // },
    best_grade(activity_grade, answers) {
      let grades = [];
      for (let i = 1; i <= 3; i++) {
        const results = answers.filter((element) => element.answer_number == i);
        if (results.length > 0) {
          results.forEach((el) => {
            if (el.grade != null) {
              // Push the grade after scaling with activity_grade
              grades.push((el.grade * (activity_grade / 100)).toFixed(2));
            }
          });
        }
      }

      if (grades.length === 0) {
        return "-";
      }

      // Return the highest grade
      return Math.max(...grades);
    },
    apiParamsConverter() {
      const apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${this.params.sortDesc ? "desc" : "asc"
          }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      if (this.filters.edu_course) {
        apiParams.edu_course = this.filters.edu_course;
      }
      if (this.filters.type) {
        apiParams.type = this.filters.type;
      }
      apiParams.activity_id = this.$route.params.Activity;
      apiParams.with = ["users_answered"];
      //console.log(apiParams);
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        //console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
  },
};
</script>
